export { default } from './Responsive';



// WEBPACK FOOTER //
// ./src/components/common/Responsive/index.js